/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCycleSubjectDtoApiResponse } from '../../models/amoxcalli-cycle-subject-dto-api-response';
import { AmoxcalliUpdateCycleSubjectDto } from '../../models/amoxcalli-update-cycle-subject-dto';

export interface ApiCycleSubjectsIdPut$Json$Params {
  id: string;
      body?: AmoxcalliUpdateCycleSubjectDto
}

export function apiCycleSubjectsIdPut$Json(http: HttpClient, rootUrl: string, params: ApiCycleSubjectsIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiCycleSubjectsIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>;
    })
  );
}

apiCycleSubjectsIdPut$Json.PATH = '/api/cycle-subjects/{id}';
